"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Skeleton = require("@insided/shared/uikit/Skeleton");

// Styles live in `../styles/index.scss` (imported there alongside the sibling
// SmartSummary / ForethoughtAgent stylesheets) so they compile in the same
// scoped context and get the shared mixins/tokens (`@include media`,
// `$spacing-*`). Importing the .scss here instead would route it through a
// path that doesn't receive those globals.

/**
 * Loading skeleton shared by AI Answers (SmartSummary) and the Forethought
 * agent's first iteration. Mirrors the answer layout — a column of text-line
 * bars on the left and two source-card placeholders on the right — so the
 * loading state occupies the same shape as the eventual answer and the box
 * doesn't jump when the real content swaps in. Reuses the shimmer animation
 * from the shared `Skeleton` uikit (`RectangleSkeleton`) rather than rolling
 * a new one.
 *
 * Header-agnostic on purpose: both callers already render their own
 * `AIAnswersHeader` above the body, so this component is just the body.
 */
// Two paragraph-like groups of text bars. Widths approximate natural prose
// (a shorter lead-in line followed by fuller lines) so the placeholder reads
// as text rather than a uniform block.
var PARAGRAPH_LINE_WIDTHS = ['62%', '96%', '88%', '74%'];

var AIAnswersSkeletonLoader = function AIAnswersSkeletonLoader() {
  return (0, _preact.h)("div", {
    className: "ai-answers-skeleton",
    "data-qa": "ai-answers-skeleton",
    "aria-hidden": "true"
  }, (0, _preact.h)("div", {
    className: "ai-answers-skeleton__main"
  }, PARAGRAPH_LINE_WIDTHS.map(function (width, index) {
    return (0, _preact.h)(_Skeleton.RectangleSkeleton, {
      key: "p1-".concat(index),
      width: width,
      height: "14px"
    });
  }), (0, _preact.h)("span", {
    className: "ai-answers-skeleton__spacer"
  }), PARAGRAPH_LINE_WIDTHS.map(function (width, index) {
    return (0, _preact.h)(_Skeleton.RectangleSkeleton, {
      key: "p2-".concat(index),
      width: width,
      height: "14px"
    });
  })), (0, _preact.h)("div", {
    className: "ai-answers-skeleton__cards"
  }, [0, 1].map(function (index) {
    return (0, _preact.h)("div", {
      className: "ai-answers-skeleton__card",
      key: "card-".concat(index)
    }, (0, _preact.h)(_Skeleton.RectangleSkeleton, {
      width: "52%",
      height: "12px"
    }), (0, _preact.h)(_Skeleton.RectangleSkeleton, {
      width: "90%",
      height: "12px"
    }), (0, _preact.h)("div", {
      className: "ai-answers-skeleton__card-footer"
    }, (0, _preact.h)(_Skeleton.RectangleSkeleton, {
      width: "22px",
      height: "22px",
      borderRadius: "6px"
    }), (0, _preact.h)(_Skeleton.RectangleSkeleton, {
      width: "38%",
      height: "12px"
    })));
  })));
};

var _default = AIAnswersSkeletonLoader;
exports.default = _default;